module.exports = __webpack_public_path__ + "static/media/m-home-bg.8c0a7c94.svg";